module.exports = __webpack_public_path__ + "h5/img/child-title4.00d85ffa.png";